"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalLinks = exports.popoverLinks = exports.guestLinks = void 0;
var guestLinks = [{
  label: 'Header.AccountLinks.Login',
  to: 'login',
  id: 'click-login'
}, {
  label: 'Header.AccountLinks.Create Account',
  to: 'create-account',
  id: 'click-create-account'
}];
exports.guestLinks = guestLinks;
var popoverLinks = [{
  label: 'Header.AccountLinks.My Account',
  to: 'account/edit',
  id: 'click-edit'
}, {
  label: 'Header.AccountLinks.Orders',
  to: 'account/order-history',
  id: 'click-order-history'
}, {
  label: 'Header.AccountLinks.Logout',
  to: 'logout',
  id: 'click-logout'
}];
exports.popoverLinks = popoverLinks;
var modalLinks = [{
  label: 'Account.Dashboard.My Profile Link',
  to: 'account/edit',
  id: 'click-edit'
}, {
  label: 'Account.Dashboard.Change Password',
  to: 'account/change-password',
  id: 'click-password'
}, {
  label: 'Account.Dashboard.Order History Link',
  to: 'account/order-history',
  id: 'click-order-history'
}, {
  label: 'Account.Dashboard.Credit Cards Link',
  to: 'account/payment-methods',
  id: 'click-credit-cards'
}, {
  label: 'Account.Dashboard.Logout Link',
  to: 'logout',
  id: 'click-logout'
}];
exports.modalLinks = modalLinks;